enum AuthFlowType {
    UNKNOWN = "UNKNOWN",
    CUSTOMER_CREATE = "CUSTOMER_CREATE",
    LOGIN = "LOGIN",
}

export default AuthFlowType;


// WEBPACK FOOTER //
// ./src/presentation/auth_flow.ts